import React, { ReactNode } from 'react';
import clsx from 'clsx';

// Define color and size keys
type BadgeColor =
  | 'blue'
  | 'gray'
  | 'red'
  | 'redPriorityHigh'
  | 'green'
  | 'yellow'
  | 'indigo'
  | 'purple'
  | 'pink';

type BadgeSize = 'xs' | 'sm' | 'md' | 'lg';

// Static class maps
const colorMap: Record<BadgeColor, string> = {
  blue: 'bg-blue-50 text-blue-400',
  gray: 'bg-gray-50 text-gray-500',
  red: 'bg-red-50 text-red-400',
  redPriorityHigh: 'bg-red-400 text-white', 
  green: 'bg-green-50 text-green-400',
  yellow: 'bg-yellow-50 text-yellow-400',
  indigo: 'bg-indigo-50 text-indigo-400',
  purple: 'bg-purple-50 text-purple-400',
  pink: 'bg-pink-50 text-pink-400',
};

const sizeMap: Record<BadgeSize, string> = {
  xs: 'text-xs px-2.5 py-0.5',
  sm: 'text-sm px-3 py-0.5',
  md: 'text-base px-3.5 py-1',
  lg: 'text-lg px-4 py-1.5',
};

// Define props interface
interface BadgeProps {
  className?: string;
  color?: BadgeColor;
  size?: BadgeSize;
  children: ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  color = 'gray',
  className,
  size = 'xs',
  children,
}) => {
  const colorClasses = colorMap[color] || colorMap.gray;
  const sizeClasses = sizeMap[size] || sizeMap.xs;

  return (
    <span
      className={clsx(
        colorClasses,
        sizeClasses,
        className,
        'font-medium ml-1 rounded-full text-nowrap',
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
